export default __webpack_public_path__ + "static/media/full2.9e2c36d6.jpg";